/* index.js */

"use strict";

module.exports = {
    PickList: require("./pick_list/PickListComponent"),
};
